module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "status"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('h2', {
    staticClass: "text-center loading"
  }, [_vm._v("Loading Data")])]) : _c('div', {
    staticClass: "panel-body"
  }, [_c('form', [(_vm.allowedToChangeStatus) ? _c('div', [(_vm.status) ? _c('div', {
    staticClass: "form-group status"
  }, [_c('div', {
    staticClass: "status-wrapper"
  }, [_c('label', [_vm._v("At this point in this current term, what are you planning to do?")]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    class: _vm.status,
    on: {
      "mousedown": function($event) {
        _vm.checkAvailability($event)
      },
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.statusChanged = true;
        _vm.selectedPolicy = _vm.status;
        _vm.newStatus.hasReadPolicy = false
      }]
    }
  }, _vm._l((_vm.statuses), function(status) {
    return _c('option', {
      domProps: {
        "value": status.value
      }
    }, [_vm._v(_vm._s(status.label))])
  }))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusChanged === true),
      expression: "statusChanged===true"
    }]
  }, [(_vm.status === 'deferring' || _vm.status === 'retaking') ? _c('div', [(_vm.status === 'deferring') ? _c('label', [_vm._v("When are you hoping to continue on?")]) : _vm._e(), _vm._v(" "), (_vm.status === 'retaking') ? _c('label', [_vm._v("When do you plan to retake this term?")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStatus.intake),
      expression: "newStatus.intake"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newStatus.intake = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.intakes), function(intake, $index) {
    return ((_vm.status === 'deferring' && $index > 1) || (_vm.status === 'retaking')) ? _c('option', {
      domProps: {
        "value": intake.date
      }
    }, [_vm._v(_vm._s(intake.label))]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.status === 'dropping') ? _c('div', [_c('label', [_vm._v("When do you plan to drop out?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStatus.intake),
      expression: "newStatus.intake"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newStatus.intake = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.intakes), function(intake) {
    return _c('option', {
      domProps: {
        "value": intake.date
      }
    }, [_vm._v(_vm._s(intake.label))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.status && _vm.status !== 'continuing') ? _c('div', [_c('label', [_vm._v("Reason")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStatus.reason),
      expression: "newStatus.reason"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.newStatus.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newStatus.reason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "documents"
  }, [_c('label', [_vm._v("Supporting Documents")]), _vm._v(" "), _c('label', {
    staticClass: "documents"
  }, [_vm._v(" Upload\n                                    "), _c('input', {
    ref: "documents",
    attrs: {
      "type": "file",
      "multiple": ""
    }
  })])])]) : _vm._e()]), _vm._v(" "), (_vm.selectedPolicy && _vm.selectedPolicy !== 'unconfirmed' && _vm.selectedPolicy !== 'continuing') ? _c('div', {
    staticClass: "policy"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.policies[_vm.selectedPolicy])
    }
  }), _vm._v(" "), (_vm.selectedPolicy === 'dropping') ? _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStatus.agreedToRefundPolicy),
      expression: "newStatus.agreedToRefundPolicy"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newStatus.agreedToRefundPolicy) ? _vm._i(_vm.newStatus.agreedToRefundPolicy, null) > -1 : (_vm.newStatus.agreedToRefundPolicy)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newStatus.agreedToRefundPolicy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newStatus.agreedToRefundPolicy = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newStatus.agreedToRefundPolicy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newStatus.agreedToRefundPolicy = $$c
        }
      }
    }
  }), _vm._v("I understand there are additional steps for a refund and that refunds are calculated based on when accounting receives the request with my banking information."), _c('br'), _c('br'), _vm._v("This must be checked to continue."), _c('br'), _c('br')])]) : _vm._e(), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStatus.hasReadPolicy),
      expression: "newStatus.hasReadPolicy"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newStatus.hasReadPolicy) ? _vm._i(_vm.newStatus.hasReadPolicy, null) > -1 : (_vm.newStatus.hasReadPolicy)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newStatus.hasReadPolicy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newStatus.hasReadPolicy = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newStatus.hasReadPolicy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newStatus.hasReadPolicy = $$c
        }
      }
    }
  }), _vm._v("I have read and agree to the above policy.")])]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusChanged === true || _vm.status === 'continuing'),
      expression: "statusChanged===true || status === 'continuing'"
    }],
    staticClass: "btn btn-xs btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateStatus()
      }
    }
  }, [_vm._v("Update Status")])]) : _vm._e(), _vm._v(" "), (_vm.pastStatuses) ? _c('div', [_c('table', {
    staticClass: "table table-striped table-bordered past-statuses"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.pastStatuses), function(status) {
    return _c('tr', [_c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.journeyDate(status.createdAt))
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("capitalize")(status.status)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(status.reason))]), _vm._v(" "), _c('td', [(status.intake) ? _c('span', [_vm._v(_vm._s(_vm._f("intakeDate")(status.intake)))]) : _vm._e()]), _vm._v(" "), _c('td', _vm._l((status.documents), function(link, $index) {
      return _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.downloadDocument(link)
          }
        }
      }, [_vm._v("Link " + _vm._s($index + 1))])
    }))])
  }))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.enrollmentLetters && _vm.enrollmentLetters.length) ? _c('div', _vm._l((_vm.enrollmentLetters), function(letter) {
    return _c('div', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadLetter(letter.url)
        }
      }
    }, [_vm._v("Enrollment Letter"), (letter.programId) ? _c('span', [_vm._v(" - " + _vm._s(_vm.getProgramName(letter.programId)))]) : _vm._e()])])
  })) : _c('div', [(_vm.extraEnrollmentLetters && _vm.extraEnrollmentLetters > 0) ? _c('div', _vm._l((_vm.extraEnrollmentLetters + 1), function(n) {
    return _c('a', {
      staticClass: "enrollment-letter",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadEnrollmentLetter(n)
        }
      }
    }, [_vm._v("Enrollment Letter #" + _vm._s(n))])
  })) : _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadEnrollmentLetter()
      }
    }
  }, [_vm._v("Enrollment Letter")])]), _vm._v(" "), _vm._l((_vm.documents), function(document) {
    return _c('div', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadSlip(document)
        }
      }
    }, [_vm._v(_vm._s(document.type))])])
  })], 2), _vm._v(" "), _vm._l((_vm.projects), function(project, $index) {
    return _c('div', {
      staticClass: "form-group"
    }, [(project.passed === true && (_vm.localStorage.roles.includes('Student') && _vm.localStorage.transitioned != 'true')) ? _c('div', {
      staticClass: "diploma-links"
    }, [_c('a', {
      attrs: {
        "href": 'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_' + _vm.localStorage.account_id + '.pdf',
        "_target": "blank"
      }
    }, [_vm._v("\n                            Digital Diploma (dark)\n                        ")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_' + _vm.localStorage.account_id + '_print.pdf',
        "_target": "blank"
      }
    }, [_vm._v("\n                            Digital Diploma (light)\n                        ")]), _vm._v(" "), _vm._m(3, true)]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Your Picks")]), _vm._v(" "), (this.path != '9200') ? _c('div', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pick Your Path:")]), _vm._v(" "), (_vm.pathName) ? _c('span', [_vm._v(_vm._s(_vm.pathName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pick Your Mentor: ")]), _vm._v(" "), (_vm.mentorName) ? _c('span', [_vm._v(_vm._s(_vm.mentorName))]) : _vm._e()])]), _vm._v(" "), (_vm.metrics) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Your Marks")]), _vm._v(" "), _c('div', {
    staticClass: "text-right download-transcript"
  }, [_c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getTranscript($event)
      }
    }
  }, [_vm._v("Download Transcript")])]), _vm._v(" "), _c('div', {
    staticClass: "metrics-container"
  }, _vm._l((_vm.metrics), function(metric) {
    return (metric.term.type !== 'mentorship') ? _c('div', {
      staticClass: "term-metrics"
    }, [_c('div', {
      staticClass: "term-header",
      on: {
        "click": function($event) {
          _vm.toggleTerm(metric.term.id)
        }
      }
    }, [(_vm.selectedTerms.includes(metric.term.id)) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    }), _vm._v("\n                                " + _vm._s(metric.term.name) + "\n                                "), (new Date(metric.term.endDate) < new Date()) ? _c('span', {
      staticClass: "total-mark"
    }, [_vm._v("\n                                    " + _vm._s(metric.totalMark) + "%  " + _vm._s(_vm.letterGrade(metric.totalMark)) + "\n                                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedTerms.includes(metric.term.id)),
        expression: "selectedTerms.includes(metric.term.id)"
      }],
      staticClass: "metrics"
    }, [_c('div', [(_vm.usesNewMarkingSystem(metric)) ? _c('span', {
      staticClass: "bold"
    }, [_vm._v("10% Live Session Attendance")]) : _c('span', {
      staticClass: "bold"
    }, [_vm._v("25% Metrics")]), _vm._v(" "), (!_vm.usesNewMarkingSystem(metric)) ? _c('div', {
      staticClass: "indent clearfix"
    }, [_vm._v("10% Video Progress: "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.video.mark) + "% " + _vm._s(metric.video.progress) + " / " + _vm._s(metric.video.totalDuration))])]) : _vm._e(), _vm._v(" "), (!_vm.usesNewMarkingSystem(metric)) ? _c('div', {
      staticClass: "indent clearfix"
    }, [_vm._v("5% Forum / Chat: "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.interactions.mark) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "indent clearfix"
    }, [_vm._v("Attendance: "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.meetings.attended) + " / " + _vm._s(metric.meetings.total))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.toggleAssignments(metric.term.id)
        }
      }
    }, [(_vm.usesNewMarkingSystem(metric)) ? _c('span', {
      staticClass: "bold"
    }, [_vm._v("40% Assignments:")]) : _c('span', {
      staticClass: "bold"
    }, [_vm._v("25% Assignments:")]), _vm._v(" "), (_vm.selectedAssignments.includes(metric.term.id)) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    })]), _vm._v(" "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.assignments.mark) + "%")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedAssignments.includes(metric.term.id)),
        expression: "selectedAssignments.includes(metric.term.id)"
      }],
      staticClass: "submissions"
    }, _vm._l((metric.assignments.assignments), function(assignment) {
      return _c('div', [_vm._v("\n                                            ID: " + _vm._s(assignment.id) + "\n                                            Week " + _vm._s(assignment.week) + ":\n                                            "), (assignment.instance['associated.name']) ? _c('span', [_vm._v(_vm._s(assignment.instance['associated.name']))]) : _vm._e(), _vm._v("\n                                            – " + _vm._s(assignment.name) + "\n                                            "), _vm._v(" "), (assignment.submission) ? _c('span', {
        staticClass: "mark"
      }, [(assignment.submission.grade == null) ? _c('span', [_vm._v("Ungraded")]) : _c('span', [_vm._v(_vm._s(assignment.submission.grade))]), _vm._v(" "), (assignment.submission.grade != null) ? _c('span', [_vm._v("%")]) : _vm._e()]) : _c('span', {
        staticClass: "mark"
      }, [_vm._v("Incomplete")])])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("50% Final Project:")]), _vm._v(" "), (metric.finalProject && new Date(metric.term.endDate) < new Date()) ? _c('span', {
      staticClass: "mark"
    }, [(metric.finalProject.submission && isNaN(metric.finalProject.mark)) ? _c('span', [_vm._v("Ungraded")]) : _vm._e(), _vm._v(" "), (!metric.finalProject.submission) ? _c('span', [_vm._v("Incomplete")]) : _vm._e(), _vm._v(" "), (metric.finalProject.submission && metric.finalProject.mark) ? _c('span', [_vm._v("\n                                            " + _vm._s(metric.finalProject.mark) + "%\n                                        ")]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
  }))]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.showOverlay) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.showOverlay = false
      }
    }
  }, [_c('div', {
    staticClass: "not-allowed"
  }, [_c('span', {
    staticClass: "close"
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                The ability to change your status is currently closed, please check your \n                "), _c('router-link', {
    attrs: {
      "to": "/journey"
    }
  }, [_vm._v("Journey")]), _vm._v(" for when it will open."), _c('br'), _c('br'), _vm._v("\n                If you need to make any changes outside our status window, please create \n                a "), _c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("Financial Ticket")]), _vm._v(" and outline your situation.                    \n            ")], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showStatusChangePopup) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.showStatusChangePopup = false
      }
    }
  }, [_c('div', {
    staticClass: "not-allowed"
  }, [_c('span', {
    staticClass: "close"
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', [_vm._v("Thank you for updating your status. The next step in your process will be to have a meeting with John Robertson, Head of Admissions, who will guide you through the next steps of the process.")]), _vm._v(" "), _vm._m(4)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("My Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("Confirming your Status is important and must be completed before the deadline outlined in your Journey. If you miss the deadline to confirm your status it will be assumed that you are continuing with the program and will be responsible for all financial obligations. We realize that situations change, and we strive to be flexible and support our students. However, this needs to be communicated well before our term starts. If you miss the deadlines, we cannot be more lenient as we coordinate with working professionals to instruct and mentor you.")]), _vm._v(" "), _c('p', [_vm._v("Note, if you are not enrolled in this current term (in an active deferral) you cannot update your status and you will continue in the term you selected prior to your deferral (seeing ‘unconfirmed’ in the table for your break below is expected in this case). There are changes happening with the structure and format of the online program, and it’s important that you connect with our Admissions team so they can work with you on building a plan to successfully complete your education.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Date Submitted")]), _vm._v(" "), _c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v("Reason")]), _vm._v(" "), _c('td', [_vm._v("Term")]), _vm._v(" "), _c('td', [_vm._v("Links")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you would like a hard copy mailed to you, please email "), _c('a', {
    attrs: {
      "href": "mailto:online@tttc.ca"
    }
  }, [_vm._v("online@tttc.ca")]), _vm._v(" with your current address"), _c('br'), _vm._v("*Mailing a hard copy may require processing fees")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("He will be reaching out to you in the next 48 hours to set a meeting time. If you'd like to reach out to him directly, his email is "), _c('a', {
    attrs: {
      "href": "mailto:john@tttc.ca"
    }
  }, [_vm._v("john@tttc.ca")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dc5ac9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Status.vue
// module id = 1999
// module chunks = 2